export default __webpack_public_path__ + "static/media/lavrus-strat.746c02eb.png";